import { COLUMN_TYPES } from "Boards/const";

export const CELL_TYPES = Object.freeze({
  BOOL: 1,
  TEXT: 2,
  NUMBER: 3,
  DATE: 4,
  DATE_TIME: 5,
  ADDRESS: 6,
  SELECT_LIST: 7,
  SIGNUP_ITEMS: 8,
  FILE: 9,
  SACRAMENT_CHURCH: 10,
});

export function getCellType(columnType) {
  switch (columnType) {
    case COLUMN_TYPES.BOOL:
    case COLUMN_TYPES.SIGNUPS_HAS_BEEN_PAID_FOR:
      return CELL_TYPES.BOOL;

    case COLUMN_TYPES.TEXT:
    case COLUMN_TYPES.EXTENDED_FIELDS_TEXT:
    case COLUMN_TYPES.SIGNUPS_CONFIRMATION_NUMBER:
    case COLUMN_TYPES.SACRAMENT_BOOK_RECORD:
      return CELL_TYPES.TEXT;

    case COLUMN_TYPES.NUMBER:
    case COLUMN_TYPES.EXTENDED_FIELDS_NUMBER:
    case COLUMN_TYPES.SIGNUPS_TOTAL_NUMBER_OF_ITEMS:
    case COLUMN_TYPES.SIGNUPS_NUMBER_OF_ITEMS:
      return CELL_TYPES.NUMBER;

    case COLUMN_TYPES.EXTENDED_FIELDS_DATE:
      return CELL_TYPES.DATE;

    case COLUMN_TYPES.SIGNUPS_SIGNED_UP_DATE:
      return CELL_TYPES.DATE_TIME;

    case COLUMN_TYPES.EXTENDED_FIELDS_ADDRESS:
      return CELL_TYPES.ADDRESS;

    case COLUMN_TYPES.EXTENDED_FIELDS_SELECT_LIST:
    case COLUMN_TYPES.EXTENDED_FIELDS_MEMBERSHIP_STATUS:
      return CELL_TYPES.SELECT_LIST;

    case COLUMN_TYPES.SIGNUPS_ITEMS_SIGNED_UP_FOR:
      return CELL_TYPES.SIGNUP_ITEMS;

    case COLUMN_TYPES.EXTENDED_FIELDS_FILE:
      return CELL_TYPES.FILE;

    case COLUMN_TYPES.SACRAMENT_CHURCH:
      return CELL_TYPES.SACRAMENT_CHURCH;

    default:
      console.info("Failed to getCellType for columnType: ", columnType);
      return undefined;
  }
}
